import { create } from 'zustand';

const useAuthStore = create((set) => ({
  zstAccountInfo: {},
  zstSetAccount: (props) => set({ zstAccountInfo: props || {} }),
  zstLogout: () => set({ zstAccountInfo: {} }),
}));

export default useAuthStore;
